import { i18n } from 'boot/i18n';
import {
  EMAIL_REGEX,
  EMAIL_URL_REGEX,
  HEX_COLOR_REGEX,
  MAIL_CHIMP_API_KEY_REGEX,
  NEWSLETTER_TAG_REGEX,
  PHONE_URL_REGEX,
  URL_REGEX,
  META_TAG_REGEX,
} from './regexp';

const validateEmail = (email) => EMAIL_REGEX.test(String(email)
  .toLowerCase());

const validateHref = (value) => {
  const lowerCaseValue = String(value)
    .toLowerCase();
  return [EMAIL_URL_REGEX, PHONE_URL_REGEX, URL_REGEX]
    .some((regex) => regex.test(lowerCaseValue));
};

// const validatePhone = (value) => parsePhoneNumber(String(value))
//   .isValid();

export default {
  REQUIRED: (value) => (!!value) || i18n.global.t('validation.required'),
  REQUIRED_IF: (value, anotherValue) => (!anotherValue || !!value) || i18n.global.t('validation.required'),
  EMAIL: (value) => validateEmail(value) || i18n.global.t('validation.email'),
  BOOLEAN_REQUIRED: (value) => value || i18n.global.t('validation.required'),
  URL: (value) => (!value || URL_REGEX.test(value)) || i18n.global.t('validation.url'),
  HEX_COLOR: (value) => !value || HEX_COLOR_REGEX.test(value) || i18n.global.t('validation.invalidValue'),
  HREF: (value) => validateHref(value) || i18n.global.t('validation.href'),
  POSITIVE: (value) => value > 0 || i18n.global.t('validation.zero'),
  POSITIVE_WITHOUT_ERROR: (value) => value > 0,
  NUMBER: (value) => !Number.isNaN(Number(value)) || i18n.global.t('validation.notNumber'),
  BETWEEN: (value, field, min, max) => (value >= min && value <= max) || i18n.global.t('validation.betweenNumber', { field, min, max }),
  // PHONE: (value) => validatePhone(value) || i18n.global.t('validation.phone'),
  MIN_LENGTH: (value, field, min, errorKeyMessage = 'validation.minLength') => (value && value.length >= min) || i18n.global.t(errorKeyMessage, { field, min }),
  MIN_LENGTH_OR_EMPTY: (value, field, min, errorKeyMessage = 'validation.minLength') => (value.length === 0 || value.length >= min) || i18n.global.t(errorKeyMessage, { field, min }),
  MAX_LENGTH: (value, field, max) => (!value || value.length <= max) || i18n.global.t('validation.maxLength', { field, max }),
  MAIL_CHIMP_API_KEY: (value) => MAIL_CHIMP_API_KEY_REGEX.test(value) || i18n.global.t('validation.invalidValue'),
  NEWSLETTER_TAG: (value) => NEWSLETTER_TAG_REGEX.test(value) || i18n.global.t('validation.invalidValue'),
  META_TAG: (value) => (!value || META_TAG_REGEX.test(value)) || i18n.global.t('validation.invalidValue'),
};
